import React from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'
import { Card, Dropdown, Form, Icon, List, Popup } from 'semantic-ui-react'

import Container from './UserCardContainer'

import Button from 'Components/StandardButton'
import Permissions from 'Components/Permissions'
import UserCardListItem from 'Components/UserCardListItem'

import * as styles from './styles'
import { THEME_COLOR } from 'Global/constants'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'
import { hasTrueValues } from 'Global/Helpers/objectHelpers'

const UserCard = props => {
  const {
    editMode,
    email,
    error,
    firstName,
    groupsOptions,
    handleDropdownGroupSelect,
    handleEmail,
    handleFirstName,
    handleLastName,
    handleSubmit,
    lastName,
    pending,
    removeGroup,
    resetPassword,
    toggleEditMode,
    user,
  } = props

  return (
    <Card color={THEME_COLOR} fluid raised>
      <Permissions
        permissions="users.editMode"
        render={() => (
          <Card.Content>
            <span style={styles.floatRight}>
              <a href="editMode" onClick={toggleEditMode}>
                <Popup content="Edit Mode" size="mini" trigger={<Icon name={!editMode ? 'lock' : 'unlock'} size="large" />} />
              </a>
            </span>
          </Card.Content>
        )}
      />

      <Card.Content>
        <Card.Header>
          {!editMode && <span>{`${user.firstName} ${user.lastName}`}</span>}

          {editMode && (
            <Permissions
              permissions="users.editMode"
              render={() => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group grouped>
                    <Form.Input icon={'tag'} loading={pending} name="firstName" onChange={handleFirstName} size="mini" value={firstName} />

                    <Form.Input icon={'tag'} loading={pending} name="lastName" onChange={handleLastName} size="mini" value={lastName} />

                    <Form.Input icon={'mail'} loading={pending} name="email" onChange={handleEmail} size="mini" value={email} />

                    <Button
                      content="Update Information"
                      disabled={hasTrueValues(pending)}
                      error={error}
                      icon="check"
                      loading={hasTrueValues(pending)}
                      fluid
                    />
                  </Form.Group>
                </Form>
              )}
            />
          )}
        </Card.Header>

        <Card.Meta>{!editMode && <span>{user.email}</span>}</Card.Meta>
      </Card.Content>

      <Card.Content extra={!editMode}>
        {!editMode && (
          <span>
            <Popup content={`${pluralize('Group', user.userGroups.length)}`} size="mini" trigger={<Icon name="address book" />} />
            {user.userGroups
              .map(group => group.name)
              .sort((a, b) => a.localeCompare(b))
              .join(', ')}
          </span>
        )}

        <br />

        {editMode && (
          <div>
            <Dropdown
              disabled={pending}
              loading={pending}
              onChange={handleDropdownGroupSelect}
              options={groupsOptions}
              placeholder={'Add Group'}
              value={''}
              fluid
              selection
            />
            <List>
              {user.userGroups
                .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                .map(group => {
                  return <UserCardListItem item={group.name} itemValue={group.id} key={group.id} remove={removeGroup} />
                })}
            </List>
          </div>
        )}
      </Card.Content>

      <Permissions
        permissions="users.resetPassword"
        render={() => (
          <Card.Content extra>
            <Button content="Reset Password" error={error} icon={'recycle'} loading={pending} onClick={resetPassword} fluid />
          </Card.Content>
        )}
      />

      {user.lastLogin ? (
        <Card.Content extra>
          <Popup content="Last Login" size="mini" trigger={<Icon name="calendar" />} />
          {getFormattedDateString(user.lastLogin)}
        </Card.Content>
      ) : (
        <Card.Content extra>
          <Popup content="Last Login" size="mini" trigger={<Icon name="calendar" />} />
          Never
        </Card.Content>
      )}
    </Card>
  )
}

UserCard.propTypes = {
  editMode: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  firstName: PropTypes.string.isRequired,
  groupsOptions: PropTypes.array.isRequired,
  handleDropdownGroupSelect: PropTypes.func.isRequired,
  handleEmail: PropTypes.func.isRequired,
  handleFirstName: PropTypes.func.isRequired,
  handleLastName: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  lastName: PropTypes.string.isRequired,
  pending: PropTypes.bool.isRequired,
  removeGroup: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
  toggleEditMode: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default Container(UserCard)
